// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    host: 'localhost:8080',
    ssl: false,
    "apiKey": "AIzaSyBe7FZhZSiogrSCv1BdC61gmYAe2JGajYA",
    "appId": "1:132387797455:web:af117e14688e7026093aba",
    "authDomain": "binarybioskop-1551559206895.firebaseapp.com",
    "databaseURL": "https://binarybioskop-1551559206895.firebaseio.com",
    "measurementId": "G-K89R8Y1Q1N",
    "messagingSenderId": "132387797455",
    "projectId": "binarybioskop-1551559206895",
    "storageBucket": "binarybioskop-1551559206895.appspot.com"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
